import { useCallback, useContext } from "react";
import { Apihost } from "../utils/Apihost";
import { RenderContext } from "../CreateContext";

/**
 * useFetchSettings フック
 * 
 * このフックは設定情報を取得し、`RenderContext`に格納するための関数を提供します。
 * 
 * @returns {Object} フックが返すオブジェクト
 * @returns {Function} fetchObjectsNow 設定を取得する関数
 */

export const useFetchSettings = () => {
    const apihost = Apihost("wall");
    const { setSettings } = useContext(RenderContext);

    const fetchSettings = useCallback(async () => {
        try {
            // 環境変数を読み込み、REACT_APP_OLD_APIがtrueの時、古いAPIを使用し, falseの時、新しいAPIを使用します
            const response = process.env.REACT_APP_OLD_API === "true"
                ? await fetch(`${apihost}/get-ks-settings`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': 'DONT_PANIC',
                    },
                    body: JSON.stringify({ SORT_FOR_SIGNAGE: true }),
                })
                : await fetch(`${apihost}/api/setting/get-ks-settings`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-api-key': 'DONT_PANIC',
                    },
                    body: JSON.stringify({ SORT_FOR_SIGNAGE: true }),
                });

            const res = await response.json();
            setSettings(res.data);
        } catch (error) {
            console.log('設定の取得に失敗しました', error);
        }
    }, [apihost, setSettings]);

    return { fetchSettings };
};
